<div class="d--f jc--c mt-5">
  <div class="d--f fd--c ai--c">
    <img class="empty-screen-image" [src]="options.imagePath" alt="" />
    <p class="mt-2">{{ options.title }}</p>
  </div>
</div>
